"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntityCRUD = useEntityCRUD;
var react_query_1 = require("@tanstack/react-query");
var api_1 = __importDefault(require("../../../../../../services/api"));
var react_1 = require("react");
function useEntityCRUD(_a) {
    var _this = this;
    var _b;
    var endpoint = _a.endpoint, entityName = _a.entityName, _c = _a.defaultPageSize, defaultPageSize = _c === void 0 ? 20 : _c, extraParams = _a.extraParams;
    var queryClient = (0, react_query_1.useQueryClient)();
    var _d = (0, react_1.useState)(1), page = _d[0], setPage = _d[1];
    var _e = (0, react_1.useState)(defaultPageSize), pageSize = _e[0], setPageSize = _e[1];
    var _f = (0, react_1.useState)(''), searchQuery = _f[0], setSearchQuery = _f[1];
    var _g = (0, react_1.useState)(null), sorting = _g[0], setSorting = _g[1];
    var queryParams = (0, react_1.useMemo)(function () {
        var params = {
            page: page,
            page_size: pageSize,
        };
        if (searchQuery) {
            params.query = searchQuery;
        }
        if (sorting) {
            var cleanFieldName = sorting.field.replace('.keyword', '');
            params.ordering =
                sorting.direction === 'desc' ? "-".concat(cleanFieldName) : cleanFieldName;
        }
        if (extraParams) {
            Object.entries(extraParams).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                params[key] = value;
            });
        }
        return params;
    }, [page, pageSize, searchQuery, sorting]);
    var listQuery = (0, react_query_1.useQuery)({
        queryKey: [entityName, queryParams],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.default.get(endpoint, {
                            params: queryParams,
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        if ((extraParams === null || extraParams === void 0 ? void 0 : extraParams.all) && Array.isArray(data)) {
                            return [2 /*return*/, {
                                    count: data.length,
                                    total_pages: 1,
                                    next: null,
                                    previous: null,
                                    has_next: false,
                                    has_previous: false,
                                    results: data,
                                    page_size: data.length,
                                    current_page: 1,
                                    took: 0,
                                }];
                        }
                        return [2 /*return*/, data];
                }
            });
        }); },
        keepPreviousData: true,
    });
    var createMutation = (0, react_query_1.useMutation)({
        mutationFn: function (item) { return __awaiter(_this, void 0, void 0, function () {
            var config, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = item instanceof FormData
                            ? { headers: { 'Content-Type': 'multipart/form-data' } }
                            : {};
                        return [4 /*yield*/, api_1.default.post(endpoint, item, config)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [entityName] });
        },
    });
    var updateMutation = (0, react_query_1.useMutation)({
        mutationFn: function (payload) { return __awaiter(_this, void 0, void 0, function () {
            var id_1, data_1, id, item, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(payload instanceof FormData && payload.has('id'))) return [3 /*break*/, 2];
                        id_1 = payload.get('id');
                        payload.delete('id');
                        return [4 /*yield*/, api_1.default.patch("".concat(endpoint).concat(id_1, "/"), payload, { headers: { 'Content-Type': 'multipart/form-data' } })];
                    case 1:
                        data_1 = (_a.sent()).data;
                        return [2 /*return*/, data_1];
                    case 2:
                        id = payload.id, item = __rest(payload, ["id"]);
                        return [4 /*yield*/, api_1.default.patch("".concat(endpoint).concat(id, "/"), item)];
                    case 3:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [entityName] });
        },
    });
    var fetchItemById = function (id) {
        return (0, react_query_1.useQuery)({
            queryKey: [entityName, id],
            queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, api_1.default.get("".concat(endpoint).concat(id, "/"))];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data];
                    }
                });
            }); },
            enabled: !!id,
        });
    };
    var deleteMutation = (0, react_query_1.useMutation)({
        mutationFn: function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.default.delete("".concat(endpoint).concat(id, "/"))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [entityName] });
        },
    });
    var pagination = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var total = ((_a = listQuery.data) === null || _a === void 0 ? void 0 : _a.count) || 0;
        var totalPages = ((_b = listQuery.data) === null || _b === void 0 ? void 0 : _b.total_pages) || 0;
        var currentPage = ((_c = listQuery.data) === null || _c === void 0 ? void 0 : _c.current_page) || page;
        var currentPageSize = ((_d = listQuery.data) === null || _d === void 0 ? void 0 : _d.page_size) || pageSize;
        return {
            page: currentPage,
            pageSize: currentPageSize,
            total: total,
            totalPages: totalPages,
            hasNext: ((_e = listQuery.data) === null || _e === void 0 ? void 0 : _e.has_next) || false,
            hasPrevious: ((_f = listQuery.data) === null || _f === void 0 ? void 0 : _f.has_previous) || false,
            sorting: sorting,
            took: ((_g = listQuery.data) === null || _g === void 0 ? void 0 : _g.took) || 0,
        };
    }, [listQuery.data, page, pageSize, sorting]);
    return {
        listQuery: __assign(__assign({}, listQuery), { data: (_b = listQuery.data) === null || _b === void 0 ? void 0 : _b.results, pagination: listQuery.data
                ? {
                    count: listQuery.data.count,
                    total_pages: listQuery.data.total_pages,
                    next: listQuery.data.next,
                    previous: listQuery.data.previous,
                    has_next: listQuery.data.has_next,
                    has_previous: listQuery.data.has_previous,
                    page_size: listQuery.data.page_size,
                    current_page: listQuery.data.current_page,
                    took: listQuery.data.took,
                }
                : undefined }),
        searchQuery: searchQuery,
        createMutation: createMutation,
        fetchItemById: fetchItemById,
        updateMutation: updateMutation,
        deleteMutation: deleteMutation,
        pagination: pagination,
        setPage: setPage,
        setPageSize: setPageSize,
        setSearchQuery: setSearchQuery,
        setSorting: setSorting,
        queryClient: queryClient,
    };
}
